export default __webpack_public_path__ + "static/media/도시농부 클래스_모바일.b71b58ff.jpg";